import { formatError } from "@/helpers/filters";
import AuthService from "../services/auth-service";

export default {
  name: "RecoverPassword",

  data: () => ({
    email: null,
    token: null,
    userPassword: null,
    passwordCheck: null,
    sendMessage: null,
    errorMessage: null,
    dialog: false,
    dialogError: false,
    snackbar: false,
    snackbarColor: "info",
    snackbarMessage: "",
    shakeAnimated: false,
    dialogTitle: "Enviando e-mail!",
    rulesEmail: [
      (value) => !!value || "Obrigatório",
      (value) => {
        const pattern =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Email inválido";
      },
    ],
    rulesPassword: [
      (value) => !!value || "Obrigatório",
      (value) => (value && value.length >= 8) || "Min 8 caracteres",
    ],
  }),

  created() {
    const emailFromQuery = this.$route.query?.email;
    this.token = this.$route.query?.token || null;
    this.email = emailFromQuery || this.$store.state.user.email || null;

    if (this.$route.query?.reason === "first-login") {
      this.showToast("Para continuar, solicite o e-mail de redefinição da sua senha.", "warning");
    } else if (this.token) {
      this.showToast("Defina sua nova senha para concluir o acesso.", "info");
    }
  },

  computed: {
    isResetStep() {
      return !!this.token;
    },
  },

  methods: {
    showToast(message, color = "info") {
      this.snackbarMessage = message;
      this.snackbarColor = color;
      this.snackbar = true;
    },
    buildRecoveryRedirect() {
      const baseUrl =
        typeof window !== "undefined" && window.location?.origin
          ? window.location.origin
          : process.env.VUE_APP_URL;

      try {
        return new URL("/recover-password", baseUrl).toString();
      } catch (_) {
        return `${process.env.VUE_APP_URL || ""}/recover-password`;
      }
    },

    async recoveryPassword() {
      if (this.isResetStep) {
        return this.resetPassword();
      }

      const variables = {
        userEmail: this.email,
        redirect: this.buildRecoveryRedirect(),
        userPassword: null,
        passwordCheck: null,
      };
      if (!this.email) {
        this.showToast("Informe o e-mail para receber o link de redefinição.", "warning");
        this.shakeAnimated = true;
        setTimeout(() => {
          this.shakeAnimated = false;
        }, 1000);
      } else {
        try {
          const response = await AuthService.recoverPassword(variables);
          this.dialogTitle = "Enviando e-mail!";
          this.sendMessage = response.data.password_recovery.message;
          this.$store.state.user.email = this.email;
          this.showToast("E-mail de redefinição enviado com sucesso.", "success");
          this.dialog = true;
          setTimeout(() => {
            (this.dialog = false), this.$router.push("/");
          }, 3000);
        } catch (error) {
          this.errorMessage = formatError(error.message);
          this.dialogError = true;
          setTimeout(() => {
            this.dialogError = false;
          }, 3000);
        }
      }
    },

    async resetPassword() {
      if (!this.userPassword || !this.passwordCheck) {
        this.showToast("Preencha os dois campos de senha para continuar.", "warning");
        this.shakeAnimated = true;
        setTimeout(() => {
          this.shakeAnimated = false;
        }, 1000);
        return;
      }

      if (this.userPassword !== this.passwordCheck) {
        this.showToast("As senhas precisam ser iguais.", "warning");
        return;
      }

      try {
        const response = await AuthService.recoverPassword({
          userEmail: null,
          redirect: null,
          userPassword: this.userPassword,
          passwordCheck: this.passwordCheck,
          token: this.token,
        });

        this.dialogTitle = "Senha alterada!";
        this.sendMessage = response.data.password_recovery.message;
        this.showToast("Senha redefinida com sucesso. Faça login para continuar.", "success");
        this.dialog = true;

        setTimeout(() => {
          this.dialog = false;
          this.$router.push("/");
        }, 3000);
      } catch (error) {
        this.errorMessage = formatError(error.message);
        this.dialogError = true;
        setTimeout(() => {
          this.dialogError = false;
        }, 3000);
      }
    },
  },
};
